export enum QuestionarioStatus {
  Rascunho = 'Rascunho',
  Publicado = 'Publicado',
}
